import { FEATURE_FLAGS } from "@/constants/featureFlags";

export type HeaderMenuAccessRule =
  | { type: "excludeApiEnvs"; envs: string[] }
  | { type: "featureFlag"; flag: keyof typeof FEATURE_FLAGS }
  | { type: "auth"; key: "admin" | "isBtdUser" }
  | { type: "releasePermission" };

export type HeaderMenuAction =
  | { type: "navigate"; path: string }
  | { type: "external"; url: string };

export type HeaderMenuItemConfig = {
  id: string;
  label: string;
  action: HeaderMenuAction;
  activePath?: string;
  activePathMatch?: "exact" | "startsWith";
  access?: HeaderMenuAccessRule[];
};

export type HeaderMenuLinkConfig = {
  type: "link";
  id: string;
  label: string;
  buttonClassName?: string;
  action: HeaderMenuAction;
  access?: HeaderMenuAccessRule[];
};

export type HeaderMenuDropdownConfig = {
  type: "dropdown";
  id: string;
  label: string;
  items: HeaderMenuItemConfig[];
  access?: HeaderMenuAccessRule[];
};

export type HeaderMenuEntryConfig = HeaderMenuLinkConfig | HeaderMenuDropdownConfig;

export const HEADER_MENU_CONFIG: HeaderMenuEntryConfig[] = [
  {
    type: "link",
    id: "home",
    label: "Home",
    buttonClassName: "no-left-padding no-shadow",
    action: { type: "navigate", path: "/" }
  },
  {
    type: "link",
    id: "job-profiles",
    label: "Job Profiles",
    buttonClassName: "no-shadow",
    action: { type: "navigate", path: "/jobProfiles" }
  },
  {
    type: "dropdown",
    id: "notarization",
    label: "Notarizations",
    access: [{ type: "excludeApiEnvs", envs: ["stg"] }],
    items: [
      {
        id: "my-notarizations",
        label: "My Notarizations",
        action: { type: "navigate", path: "/notarization/mynotarization" },
        activePath: "/notarization/mynotarization"
      },
      {
        id: "all-notarizations",
        label: "All Notarizations",
        action: { type: "navigate", path: "/notarization" },
        activePath: "/notarization"
      }
    ]
  },
  {
    type: "dropdown",
    id: "item",
    label: "Items",
    access: [{ type: "featureFlag", flag: "ENABLE_PLC_WORKSPACE" }],
    items: [
      {
        id: "my-items",
        label: "My Items",
        action: { type: "navigate", path: "/item/myitem" },
        activePath: "/item/myitem"
      },
      {
        id: "all-items",
        label: "All Items",
        action: { type: "navigate", path: "/item" },
        activePath: "/item"
      }
    ]
  },
  {
    type: "dropdown",
    id: "jobs",
    label: "Jobs",
    items: [
      {
        id: "my-jobs",
        label: "My Jobs",
        action: { type: "navigate", path: "/jobs/myjob" },
        activePath: "/jobs/myjob"
      },
      {
        id: "all-jobs",
        label: "All Jobs",
        action: { type: "navigate", path: "/jobs" },
        activePath: "/jobs"
      }
    ]
  },
  {
    type: "dropdown",
    id: "release",
    label: "Releases",
    access: [{ type: "releasePermission" }],
    items: [
      {
        id: "my-release",
        label: "My Release",
        action: { type: "navigate", path: "/releases/myrelease" },
        activePath: "/releases/myrelease"
      },
      {
        id: "all-release",
        label: "All Release",
        action: { type: "navigate", path: "/releases" },
        activePath: "/releases"
      }
    ]
  },
  {
    type: "link",
    id: "btd",
    label: "BTD",
    buttonClassName: "no-shadow",
    action: { type: "navigate", path: "/btd" },
    access: [{ type: "auth", key: "isBtdUser" }]
  },
  {
    type: "dropdown",
    id: "manifest",
    label: "Manifest",
    access: [{ type: "auth", key: "admin" }],
    items: [
      {
        id: "manifest-search",
        label: "View",
        action: { type: "navigate", path: "/manifest/view" },
        activePath: "/manifest/view"
      },
      {
        id: "manifest-edit",
        label: "Edit",
        action: { type: "navigate", path: "/manifest/edit" },
        activePath: "/manifest/edit"
      },
      {
        id: "manifest-activate",
        label: "Activate",
        action: { type: "navigate", path: "/manifest/activate" },
        activePath: "/manifest/activate"
      },
      {
        id: "manifest-autoupdate",
        label: "Auto Update",
        action: { type: "navigate", path: "/manifest/autoupdate" },
        activePath: "/manifest/autoupdate"
      },
    ]
  },
  {
    type: "dropdown",
    id: "tools",
    label: "Tools",
    items: [
      {
        id: "component-versions",
        label: "Component Versions",
        action: { type: "navigate", path: "/tools/componentversions" },
        activePath: "/tools/componentversions"
      },
      {
        id: "analytics",
        label: "Analytics",
        action: { type: "navigate", path: "/admin/analytics" },
        activePath: "/admin/analytics",
        access: [{ type: "auth", key: "admin" }]
      },
      {
        id: "debug-dashboard",
        label: "Debug dashboard",
        action: { type: "navigate", path: "/admin" },
        activePath: "/admin"
      }
    ]
  }
];
